import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=39d2b2ba&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=39d2b2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d2b2ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39d2b2ba')) {
      api.createRecord('39d2b2ba', component.options)
    } else {
      api.reload('39d2b2ba', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=39d2b2ba&scoped=true&", function () {
      api.rerender('39d2b2ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8fdbsM39x2cfq/JS/comp/CookieBox.vue"
export default component.exports